<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('id')">
              id
              <i
                :class="
                  currentSort === 'id'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('desc')">
              Kota/Kabupaten
              <i
                :class="
                  currentSort === 'desc'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('kota')">
              Kecamatan
              <i
                :class="
                  currentSort === 'kota'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('updatedAt')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'updatedAt'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('update_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'update_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('active')">
              active
              <i
                :class="
                  currentSort === 'active'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('note')">
              catatan
              <i
                :class="
                  currentSort === 'note'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ list.id }}</td>
            <td>{{ $get(list, 'city.desc', '') }}</td>
            <td>{{ list.desc }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <KBLI
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    KBLI: () => import('@/views/MasterData/Edit/LegalDoc/Kecamatan.vue'),
  },

  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: 0,
        desc: '',
        kota: '',
        updatedAt: '',
        update_by: '',
        active: '',
        note: '',
      },
      data: [
        {
          id: 1,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Sawang',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 1',
        },
        {
          id: 2,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Nisam',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 2',
        },
        {
          id: 3,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Nisam Antara',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 3',
        },
        {
          id: 4,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Banda Baro',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 4',
        },
        {
          id: 5,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Kuta Makmur',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 5',
        },
        {
          id: 6,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Simpang Kramat',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 6',
        },
        {
          id: 7,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Syamtalira Bayu',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 7',
        },
        {
          id: 8,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Geureudong Pase',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 8',
        },
        {
          id: 9,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Meurah Mulia',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 9',
        },
        {
          id: 10,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Matang Kuli',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 10',
        },
        {
          id: 11,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Paya Bakong',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 11',
        },
        {
          id: 12,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Pirak Timu',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 12',
        },
        {
          id: 13,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Cot Girek',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 13',
        },
        {
          id: 14,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Tanah Jambo Aye',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 14',
        },
        {
          id: 15,
          desc: 'Kabupaten Aceh Utara',
          kota: 'Langkahan',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 15',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        desc: data.desc,
        kota: data.kota,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    kecamatanData() {
      const result = this.$store.state.mdDatabaseStore.kecamatanData
      return result
    },
    sortedData() {
      return this.kecamatanData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
